import script from "./RecordDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordDetails.vue?vue&type=script&setup=true&lang=js"

import "./RecordDetails.vue?vue&type=style&index=0&id=af903996&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af903996"]])

export default __exports__